/* rw.js — fiche produit : la galerie n'affiche que les vues du coloris choisi. */
(function () {
  function colorOf(root) {
    var checked = root.querySelector('input[type="radio"]:checked[name="Coloris"]');
    return checked ? checked.value : null;
  }
  function apply(root) {
    var sid = root.getAttribute('data-section');
    var list = document.getElementById('Slider-Gallery-' + sid);
    if (!list) return;
    var color = colorOf(root);
    var items = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    var marker = color ? '— ' + color + ' —' : null;
    var any = marker && items.some(function (li) { return (li.getAttribute('data-alt') || '').indexOf(marker) > -1; });
    var firstShown = null;
    items.forEach(function (li, i) {
      var show = !any || (li.getAttribute('data-alt') || '').indexOf(marker) > -1;
      li.classList.toggle('rw-hide', !show);
      var dot = document.querySelectorAll('#GalleryViewer-' + sid + ' .slider__dots button')[i];
      if (dot) dot.classList.toggle('rw-hide', !show);
      if (show && !firstShown) firstShown = li;
    });
    items.forEach(function (li) { li.classList.remove('is-active'); });
    if (firstShown) firstShown.classList.add('is-active');
    list.scrollLeft = 0;
    thumbs(sid, list, items.filter(function (li) { return !li.classList.contains('rw-hide'); }));
  }
  function thumbs(sid, list, shown) {
    var host = document.getElementById('GalleryViewer-' + sid);
    if (!host) return;
    var bar = document.getElementById('rw-thumbs-' + sid);
    if (!bar) { bar = document.createElement('div'); bar.id = 'rw-thumbs-' + sid; bar.className = 'rw-thumbs'; host.parentNode.insertBefore(bar, host.nextSibling); }
    bar.innerHTML = '';
    if (shown.length < 2) return;
    shown.forEach(function (li, i) {
      var img = li.querySelector('img'); if (!img) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'rw-thumb' + (i === 0 ? ' is-on' : '');
      b.setAttribute('aria-label', 'Vue ' + (i + 1));
      var t = document.createElement('img'); t.src = (img.currentSrc || img.src); t.alt = ''; t.loading = 'lazy'; b.appendChild(t);
      b.addEventListener('click', function () {
        list.scrollTo({ left: li.offsetLeft - list.offsetLeft, behavior: 'smooth' });
        bar.querySelectorAll('.rw-thumb').forEach(function (x) { x.classList.remove('is-on'); }); b.classList.add('is-on');
      });
      bar.appendChild(b);
    });
    if (!list.__rwScroll) {
      list.__rwScroll = true;
      list.addEventListener('scroll', function () {
        var vis = Array.prototype.filter.call(list.querySelectorAll('.product__media-item'), function (l) { return !l.classList.contains('rw-hide'); });
        var idx = 0, best = 1e9;
        vis.forEach(function (l, i) { var d = Math.abs(l.offsetLeft - list.offsetLeft - list.scrollLeft); if (d < best) { best = d; idx = i; } });
        bar.querySelectorAll('.rw-thumb').forEach(function (x, i) { x.classList.toggle('is-on', i === idx); });
      }, { passive: true });
    }
  }
  function run() { document.querySelectorAll('variant-selects').forEach(apply); }
  document.addEventListener('change', function (e) {
    var vs = e.target.closest && e.target.closest('variant-selects');
    if (vs) setTimeout(function () { apply(vs); }, 0);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();
